import React from "react";
import { Building2 } from "lucide-react";

import DashboardLayout from "src/components/layout/dashboard/Layout";
import Card from "src/components/common/card/Card";
import CardHeader from "src/components/common/card/CardHeader";
import TenantDetailsCard from "src/components/cards/TenantDetailsCard";

const SettingsOrganizationPage: React.FC = () => {
  return (
    <DashboardLayout
      meta={{
        title: "Organization | Invyntra",
        description: "Manage your company details and branding.",
        keywords: "organization, company details, settings, invyntra",
      }}
    >
      <div className="mx-auto max-w-3xl space-y-4">
        <div className="flex items-start gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300">
            <Building2 size={26} />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              Organization
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Company details shown on invoices and shared with your team.
            </p>
          </div>
        </div>

        <Card>
          <CardHeader title="Company details" />
          <TenantDetailsCard />
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default SettingsOrganizationPage;
